// src/components/common/TitleSearchModal.jsx

import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../context/AppContext';

const TitleSearchModal = ({ isOpen, onClose, onApply, currentTitle = '' }) => {
  const { t } = useAppContext();
  const [titleSearch, setTitleSearch] = useState(currentTitle);

  useEffect(() => {
    setTitleSearch(currentTitle);
  }, [currentTitle]);

  const handleApply = () => {
    onApply(titleSearch.trim());
    onClose();
  };

  const handleClear = () => {
    setTitleSearch('');
    onApply('');
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleApply();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        {/* Header */}
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold">{t('telus.modal.titleSearch.header')}</h2>
        </div>

        {/* Content */}
        <div className="p-4">
          <div className="mb-4">
            <label htmlFor="title-search" className="block text-sm font-medium text-gray-700 mb-2">
              {t('telus.modal.titleSearch.label')}
            </label>
            <input
              id="title-search"
              type="text"
              placeholder={t('telus.modal.titleSearch.placeholder')}
              value={titleSearch}
              onChange={(e) => setTitleSearch(e.target.value)}
              onKeyDown={handleKeyPress}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              autoFocus
            />
          </div>
          
          {currentTitle && (
            <div className="mb-4 p-3 bg-blue-50 rounded-md">
              <p className="text-sm text-blue-800">
                <span className="font-medium">{t('telus.modal.titleSearch.currentFilter')}</span> "{currentTitle}"
              </p>
            </div>
          )}
          
          <div className="text-xs text-gray-500">
            <p>• {t('telus.modal.titleSearch.help1')}</p>
            <p>• {t('telus.modal.titleSearch.help2')}</p>
            <p>• {t('telus.modal.titleSearch.help3')}</p>
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-gray-200 flex justify-end space-x-2 bg-gray-50">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {t('telus.modal.titleSearch.cancel')}
          </button>
          <button
            onClick={handleClear}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {t('telus.modal.titleSearch.clear')}
          </button>
          <button
            onClick={handleApply}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            {t('telus.modal.titleSearch.apply')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TitleSearchModal;
